<script>
export default {
  name: 'BaseModal',
  props: {
    mobileFullScreen: {
      type: Boolean,
      default: false
    },
    showCloseIcon: {
      type: Boolean,
      default: true
    },
    backgroundColour: {
      type: String,
      default: 'white'
    },
    maxWidth: {
      type: Number,
      required: false
    }
  },
  computed: {
    modalStyle() {
      if (!this.maxWidth) return {}
      return {
        '--modal-width': `${this.maxWidth}px`
      }
    },
    hasActionsSlot() {
      return !!this.$slots['modal-actions']
    }
  },
  mounted() {
    window.addEventListener('keyup', this.keyup)
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyup)
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    keyup(event) {
      if (!this.showCloseIcon) return
      if (event.keyCode === 27 || event.code === 'escape') {
        this.$emit('closeModal')
      }
    }
  }
}
</script>

<template lang="pug">
transition(name='modal')
  .modal-mask.grid-container-fluid
    .grid-x
      .hide-for-small-only.medium-3.large-3
      .cell.medium-8.medium-offset-2.large-6.large-offset-0.main-content
        .modal-container(
          :class='[{ "mobile-full-screen": mobileFullScreen }, `bg--${backgroundColour}`]'
          :style='modalStyle'
        )
          .modal-header
            slot(name='modal-header')
            img.close-btn(
              v-if='showCloseIcon'
              src='../../assets/images/icons/close.svg'
              @click='closeModal'
            )
          .modal-body
            slot(name='modal-body')
            .modal-actions(v-if='hasActionsSlot')
              slot(name='modal-actions')
</template>

<style lang="stylus">
@import '../../assets/styles/modules/*'
.modal-mask
  position: fixed
  z-index: 9998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .35)
  display: block
  transition: opacity .3s ease
  overflow-x: hidden
  overflow-y: scroll
.modal-container
  margin: 10vh auto
  position: relative
  padding: 20px 30px
  vertical-align: middle
  border-radius: 5px
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
  transition: all .3s ease
  max-width: var(--modal-width)
.mobile-full-screen
  margin: 0
  width: 100%
  min-height: 100vh
  border-radius: 0
  box-shadow: none
  word-break: break-word
  max-width: 100%
  +media-breakpoint-up(md)
    margin: 10vh auto
    width: 80%
    max-width: var(--modal-width, 1680px)
    min-height: 0
    border-radius: 5px
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33)
.modal-header
  .close-btn
    position: absolute
    right: 30px
    top: 25px
    height: 20px
    width: 20px
    cursor: pointer
    transition: 0.2s
    &:hover
    &:active
    &:focus
      color: THRIVA.colours.carbon
.modal-body
  margin: 20px 0
  h3
    margin-bottom: 5px
  .multiselect
    margin-bottom: 20px
.modal-actions
  margin-top: 30px
  position: absolute
  bottom: 20px
  .button
    line-height: 1
  +media-breakpoint-up(600px)
    position: relative
    width: auto
    bottom: unset
.modal-default-button
  float: right
.modal-enter
  opacity: 0
.modal-leave-active
  opacity: 0
.modal-enter
.modal-leave-active
  .modal-container
    -webkit-transform: scale(1.1)
    transform: scale(1.1)
</style>
